module.exports = __webpack_public_path__ + "img/1_hybrid-sp-2.00f077c1.gif";